var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsoSeperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 17,
    viewBox: "0 0 370 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2521_2738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.358 9.15C186.358 11.586 184.608 13.126 182.424 13.126C180.254 13.126 178.602 11.586 178.602 9.15C178.602 6.728 180.31 5.202 182.48 5.202C184.664 5.202 186.358 6.728 186.358 9.15ZM179.904 9.15C179.904 11.096 181.094 12.006 182.424 12.006C183.754 12.006 185.056 11.096 185.056 9.15C185.056 7.218 183.782 6.308 182.466 6.308C181.122 6.308 179.904 7.218 179.904 9.15ZM189.307 8.828V13H188.033V5.328H189.307V6.574C189.741 5.72 190.567 5.188 191.785 5.188V6.504H191.449C190.231 6.504 189.307 7.05 189.307 8.828Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 166,
    height: 1,
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 8,
    width: 166,
    height: 1,
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2521_2738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsoSeperator);
export default __webpack_public_path__ + "static/media/sso-seperator.d2e4bdb26cc44aa2fd12e169ec112daf.svg";
export { ForwardRef as ReactComponent };